import { gql } from '@apollo/client';

export const CREATE_HONORARIO_FIDELIZADO = gql`
  mutation createHonorarioFidelizado($input: AddHonorarioFidelizadoInput!) {
    createHonorarioFidelizado(input: $input) {
      idHonorarioFidelizado
      descripcion
    }
  }
`;

export const UPDATE_HONORARIO_FIDELIZADO = gql`
  mutation updateHonorarioFidelizado($input: EditHonorarioFidelizadoInput!) {
    updateHonorarioFidelizado(input: $input) {
      idHonorarioFidelizado
      descripcion
    }
  }
`;

export const buildCreateInput = (formData) => ({
  descripcion:            formData.descripcion,
  idDelegacion:           formData.idDelegacion,
  idTipoProfesional:      formData.idTipoProfesional,
  idFiguraProfesional:    formData.idFiguraProfesional,
  idClaseMonitoreo:       formData.idClaseMonitoreo,
  importe:                parseFloat(formData.importe),
  fechaExpira:            formData.fechaExpira,
  activo:                 formData.activo,
  observacion:            formData.observacion || null,
  idsProfesionalesIncluidos: formData.idsProfesionalesIncluidos ?? [],
});

export const buildEditInput = (formData) => ({
  idHonorarioFidelizado: formData.idHonorarioFidelizado,
  ...buildCreateInput(formData),
});
